import { ConfigType } from "../utils/requestAPI";
interface FilterValues {
  page: number;
  limit: number;
  filter: {
    mode: string;
  };
}
const reports = {
  getReports: (params?: FilterValues): ConfigType => {
    return {
      method: "get",
      url: "reports",
      params,
    };
  },
  changeReportStatus: (
    reportId: string,
    status: "Open" | "Acknowledged" | "InProgress" | "Resolved" | "Closed"
  ): ConfigType => {
    return {
      method: "put",
      url: `reports/${reportId}/status`,
      data: {
        status,
      },
    };
  },
  getSingleReport: (id: string): ConfigType => {
    return {
      method: "get",
      url: `reports/${id}`,
    };
  },
  postComment: ({
    id,
    data,
  }: {
    id: string;
    data: { comment: string; commentId?: string };
  }): ConfigType => {
    return {
      method: "put",
      url: `reports/${id}/comment`,
      data,
    };
  },
  deleteComment: ({
    id,
    commentId,
  }: {
    id: string;
    commentId?: string;
  }): ConfigType => {
    return {
      method: "delete",
      url: `reports/${id}/comment/${commentId}`,
    };
  },
};

export default reports;
